import {
    useConfirmMutation,
} from "_services/auth";

import { useLocation } from "react-router";

import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";

import { useEffect, useState } from "react";


export default function Confirm() {
    const sendGTM = useGTMDispatch();

    const [confirm, { isLoading, isSuccess }] = useConfirmMutation();

    const location = useLocation();

    useEffect(() => {
        const token = new URLSearchParams(location.search).get("token");
        if (token) {
            (async () => {
                await confirm(token);
                if (isSuccess) {
                    const event = { "event": "loginDone", "value": { "method": 'classic' } };
                    sendGTM(event);
                }
            })();
        }
    }, []);

    return <div>Confirming account</div>
}